<template>
  <div>
    <div v-if="v.$error">
      <base-input-error v-if="showError('required')">
        Este campo es obligatorio
      </base-input-error>

      <base-input-error v-else-if="showError('email')">
        Por favor, introduce un email válido
      </base-input-error>

      <base-input-error v-else-if="showError('minLength')">
        La contraseña debe tener al menos {{ v.$params.minLength.min }} caracteres
      </base-input-error>

      <base-input-error v-else-if="showError('maxLength')">
        La longitud máxima del campo no puede exceder
        {{ v.$params.maxLength.max }} caracteres
      </base-input-error>

      <base-input-error v-else-if="showError('sameAsPassword')">
        Por favor, asegúrate de que las contraseñas coinciden
      </base-input-error>
    </div>

    <div v-else-if="serverErrors[name]">
      <!-- eslint-disable -->
      <BaseInputError>
        {{ serverErrors[name][0] }}
      </BaseInputError/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState('forms', ['serverErrors']),
  },

  methods: {
    showError(validator) {
      return (
        Object.keys(this.v.$params).includes(validator) && !this.v[validator]
      )
    },
  },
}
</script>
